
import * as type from './types';

export function getNotificationCount(data) {
    return {
        type: type.GET_NOTIFICATION_COUNT_REQUESTED,
        data: data,
    }
};